import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { AIAKoreaDemo } from './demos';

/**
 * StaticDemo - Central router for company-specific static demos
 *
 * Usage: /static?company=<company-code>
 *
 * Supported companies:
 * - aia: AIA Korea AI Coach Demo
 *
 * Easy to extend: Add new cases to the switch statement below
 */
const StaticDemo: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const company = searchParams.get('company')?.toLowerCase();

  useEffect(() => {
    // If no company specified, redirect to home
    if (!company) {
      console.warn('No company parameter provided. Redirecting to home.');
      navigate('/');
    }
  }, [company, navigate]);

  // Route to appropriate company demo
  const renderDemo = () => {
    switch (company) {
      case 'aia':
        return <AIAKoreaDemo />;

      // Easy to add more companies:
      // case 'sompo':
      //   return <SompoDemo />;
      // case 'boi':
      //   return <BOIDemo />;

      default:
        return (
          <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-purple-600 to-indigo-600">
            <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md text-center">
              <h1 className="text-2xl font-bold text-gray-800 mb-4">
                Demo Not Found
              </h1>
              <p className="text-gray-600 mb-6">
                The demo for company <span className="font-mono bg-gray-100 px-2 py-1 rounded">{company}</span> does not exist.
              </p>
              <button
                onClick={() => navigate('/')}
                className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-6 py-2 rounded-lg hover:shadow-lg transition-all"
              >
                Return Home
              </button>
            </div>
          </div>
        );
    }
  };

  if (!company) {
    return null;
  }

  return renderDemo();
};

export default StaticDemo;
